import { useState } from "react";
import { Container, Text } from "@simplybusiness/mobius";
import { getCoversByTrade } from "../../../utils";
import { CoverDisplay } from "./CoverDisplay/CoverDisplay";
import { TradeSelection } from "./TradeSelection/TradeSelection";
import { LetDown } from "./LetDown/LetDown";
import type { TradeOption } from "@simplybusiness/mobius-trade-selector";
import type { Site, Vertical } from "../../../types";

export type DynamicContentProps = {
  site: Site;
  vertical: Vertical;
  closeModalCallback: () => void;
  fireEvent: (action: string) => void;
};

export const DynamicContent = ({
  site,
  vertical,
  closeModalCallback,
  fireEvent,
}: DynamicContentProps) => {
  const [selectedTrade, setSelectedTrade] = useState<TradeOption | null>(null);
  const [ctaPressed, setCTAPressed] = useState(false);
  const tradeCovers = getCoversByTrade(selectedTrade?.value);

  const pressedButInvalidTrade = ctaPressed && selectedTrade && !tradeCovers;
  const pressedAndValidTrade = ctaPressed && selectedTrade && tradeCovers;
  const haventPressed = !ctaPressed;

  return (
    <>
      <Container className="mobius-interventions__coverage-diagnosis-dynamic-content">
        {pressedButInvalidTrade && (
          <LetDown fireEvent={fireEvent} onCTAClick={closeModalCallback} />
        )}
        {pressedAndValidTrade && (
          <CoverDisplay
            trade={selectedTrade.value}
            onCTAClick={closeModalCallback}
            fireEvent={fireEvent}
          />
        )}
        {haventPressed && (
          <TradeSelection
            site={site}
            vertical={vertical}
            setSelectedTrade={setSelectedTrade}
            setCTAPressed={setCTAPressed}
            fireEvent={fireEvent}
          />
        )}
      </Container>
      {pressedAndValidTrade && (
        <Text
          variant="legal"
          className="mobius-interventions__coverage-diagnosis-disclaimer"
          data-testid="coverage-diagnosis-disclaimer"
        >
          *Other cover options will be available when you complete your quote
        </Text>
      )}
    </>
  );
};
